import * as React from 'react';
import {Guideline} from '@epic-ui/icons';

import {Option} from './IntervalRadioGroup';
import {Tooltip} from '../../../../../../components';
import {LockIcon} from '../../../../../common/icon';

import {StyledPaper, StyledChip, StyledContentWrapper, StyledIconWrapper} from './styles';

export interface IntervalRadioGroupPlaceholderProps {
    tooltip: string;
    options: Option[];
    value: Option;
}

const IntervalRadioGroupPlaceholder: React.FC<IntervalRadioGroupPlaceholderProps> = ({
    tooltip,
    options,
    value
}) => {
    const {value: selected} = value;

    return (
        <>
            {options.map(({value, label}) => {
                if (value === selected) {
                    return (
                        <StyledPaper key={value}>
                            <LockIcon />
                            <StyledContentWrapper>{label}</StyledContentWrapper>
                            <Tooltip placement="top" title={tooltip}>
                                <StyledIconWrapper>
                                    <Guideline />
                                </StyledIconWrapper>
                            </Tooltip>
                        </StyledPaper>
                    );
                } else {
                    return <StyledChip key={value} label={label} />;
                }
            })}
        </>
    );
};

export default IntervalRadioGroupPlaceholder;
